import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { TenantsListPage } from '@/features/tenants/TenantsListPage';
import { NewTenantPage } from '@/features/tenants/NewTenantPage';
import { TenantDetailPage } from '@/features/tenants/TenantDetailPage';
import { OperatorsPage } from '@/features/operators/OperatorsPage';
import { AdminShell } from '@/shared/layout/AdminShell';
import { RequireAuth } from '@/shared/layout/RequireAuth';
import { RequirePlatformAdmin } from '@/shared/layout/RequirePlatformAdmin';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <RequirePlatformAdmin>
              <AdminShell />
            </RequirePlatformAdmin>
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="empresas" element={<TenantsListPage />} />
        <Route path="empresas/nueva" element={<NewTenantPage />} />
        <Route path="empresas/:id" element={<TenantDetailPage />} />
        <Route path="operadores" element={<OperatorsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
